import React, {useEffect, useState} from 'react';
import {Modal, Form, Input, Button, message, Card, Select} from 'antd';
import {SaveOutlined} from '@ant-design/icons';
import {useGetMeQuery} from "../slices/rootApiSlices/authApiSlice";
import {useSelector} from "react-redux";
import {useProfileUpdateMutation} from "../slices/rootApiSlices/settingsApiSlice";

const UserModal = ({isModalVisible, handleModalClose}) => {

    const {user} = useSelector(state => state.auth)
    const {refetch, data, error} = useGetMeQuery(user?.token);
    const [updataHandle, updateLoading] = useProfileUpdateMutation()
    const [form] = Form.useForm();
    const {Option} = Select;

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                name: data?.user?.name,
                isActive: data?.user?.isActive,
                language: data?.user?.language,
                phoneNumber: data?.user?.phoneNumber
            });
        }
    }, [data, user, form]);

    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [language, setLanguage] = useState("");
    const [isActive, setIsActive] = useState(false);

    const updateProfile = async () => {
        const newProfile = {
            isActive: form.getFieldValue("isActive"),
            name: form.getFieldValue("name"),
            language: form.getFieldValue("language"),
            phoneNumber: form.getFieldValue("phoneNumber"),
        }
        try {
            const res = await updataHandle({token: user?.token, data: newProfile, id: data?.user?.user_id}).unwrap();
            console.log(res);
            refetch();
            message.success(res?.messageTR, 3);
        } catch (e) {
            console.log(e);
            message.error('İşlem başarısız')
        }
    }

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        message.error(errorInfo, 3)
    };

    return (
        <Modal
            open={isModalVisible}
            onCancel={handleModalClose}
            width={600}
            footer={[
                <Button key="submit" type="primary" loading={updateLoading} onClick={updateProfile}
                        icon={<SaveOutlined/>}>
                    Güncelle
                </Button>
            ]}
        >
            <Card
                title="Hesap Bilgileri" size="small"
                style={{borderColor: 'lightgray', boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.1)', marginTop: 25}}
                type="inner"
                bordered={true}
            >
                {error && <div>Hata il karşılaşıldı</div>}
                <Form
                    name="update-user"
                    form={form}
                    onFinish={updateProfile}
                    autoComplete="off"
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        name="name"
                        label="İsim / Soyisim"
                        rules={[{
                            required: true, message: 'Lütfen isim giriniz !',
                        },]}
                        onChange={e => setName(e.target.value)}
                        value={name}
                    >
                        <Input placeholder="İsim"/>
                    </Form.Item>
                    <Form.Item
                        name="phoneNumber"
                        label="Telefon (GSM)"
                        rules={[{
                            required: true, message: 'Lütfen isim giriniz !',
                        },]}
                        onChange={e => setPhoneNumber(e.target.value)}
                        value={phoneNumber}
                    >
                        <Input placeholder="Telefon (GSM)"/>
                    </Form.Item>
                    <Form.Item
                        label="Durumu"
                        name="isActive"
                        rules={[
                            {
                                required: true,
                                message: 'lütfen durum giriniz !',
                            },
                        ]}
                        value={isActive}
                    >
                        <Select
                            onChange={(e) => setIsActive({...isActive})}
                            placeholder="Durum seçiniz.."
                            allowClear
                            disabled={true}
                        >
                            <Option value={true}>Aktif</Option>
                            <Option value={false}>Pasif</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Dil"
                        name="language"
                        rules={[
                            {
                                required: true,
                                message: 'lütfen dil seçiniz !',
                            },
                        ]}
                        value={language}
                    >
                        <Select
                            onChange={() => setLanguage({...language})}
                            placeholder="Dil seçiniz.."
                            allowClear
                        >
                            <Option value="tr">Türkçe</Option>
                            <Option value="en">İngilizce</Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    );
};

export default UserModal;
